import React from "react";
import { POINTS_ADMIN } from "../../config/lang";
import { translate } from "../../util/util";

// Resolve a readable label from an FK/M2M value that may be a full object
// (name, or first/last name for users) or a bare id.
function entityLabel(v) {
  if (v === null || v === undefined) return "";
  if (typeof v !== "object") return String(v);
  if (v.name) return v.name;
  if (v.first_name || v.last_name) return `${v.first_name || ""} ${v.last_name || ""}`.trim();
  return v.label || v.title || (v.id != null ? String(v.id) : "");
}

function display(field, value, lang) {
  if (value === null || value === undefined || value === "") return "—";
  if (field.type === "checkbox") return value ? "✓" : "—";
  if (field.type === "entity") {
    if (Array.isArray(value)) {
      if (!value.length) return "—";
      // If the API returned full objects, list their names; if only ids, show the count.
      if (value.every(it => it && typeof it === "object")) {
        return (
          <span className="pt-chips-view">
            {value.map((it, i) => (
              <span className="pt-chip" key={it.id != null ? it.id : i}>{entityLabel(it)}</span>
            ))}
          </span>
        );
      }
      return `${value.length}`;
    }
    return entityLabel(value) || "—";
  }
  if (field.type === "coordinate" || field.type === "location") return value.latitude !== undefined && value.longitude !== undefined ? value.latitude + ", " + value.longitude : "—";
  if (field.type === "chips") return (value || []).join(", ") || "—";
  if (field.type === "keyvalue") {
    const entries = value && typeof value === "object" ? Object.entries(value) : [];
    return entries.length ? entries.map(([k, v]) => `${k}: ${v}`).join(", ") : "—";
  }
  if (field.type === "image") return value ? <img src={value} className="pt-image-preview" alt="" /> : "—";
  if (field.type === "textarea" && typeof value === "object") {
    const s = JSON.stringify(value);
    return s === "{}" || s === "[]" ? "—" : s;
  }
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
}

export default function ResourceView({ descriptor, item, lang }) {
  const G = POINTS_ADMIN;
  const Panel = descriptor.detailPanel;
  return (
    <div className="mp-view">
      <div className="mp-view-grid">
        <div className="mp-view-info-card">
          {descriptor.fields.map(f => (
            <div className="mp-view-info-row" key={f.name}>
              <span className="mp-view-info-label">{translate(G, f.label, lang) || f.label}</span>
              <span className="mp-view-info-value">{display(f, item[f.name], lang)}</span>
            </div>
          ))}
        </div>
      </div>
      {Panel && <div className="pt-view-panel"><Panel item={item} lang={lang} /></div>}
    </div>
  );
}
